import React from "react";
import { Box, IconButton } from "@mui/material";
import {Button, Modal as MuiModal} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import inActiveIcon from "../../assets/images/inactive.svg";


const UserExistCheckModal = ({open,onOk,onClose,onConfirm,
  onReject,style,buttonStyle,message,optionA,optionB,onSubmitModal})=>{
    return(
        <>

    <MuiModal
            open={open}
            // title="Delete"
            onOk={onOk}
            onCancel={onClose}
            footer={null}
          >
            <Box sx={style}>
          <div 
            style={{ 
              display: 'flex', 
              justifyContent: 'end', 
              alignItems: 'center', 
              padding: '15px',
              position: 'relative',
              width: '100%',
            }}
          > 
          
            <div className="warning-position">
             <img src={inActiveIcon} alt="" className="" style={{width: '70px'}} />
           </div>

            <IconButton size="small" onClick={onClose} >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-wrapper">
            <div className="important-msg">
                  <p>{message}</p>
            </div>
              {/* <div className="form-check mt-4">
              <input className="form-check-input" type="checkbox" value={isRfidDeleted} id="flexCheckDefault" style={{cursor: 'pointer'}} onChange={handleCheckboxChange}/>
              <label className="form-check-label" for="flexCheckDefault" style={{color: '#00000080', fontSize: '18px'}}>
              Permanently delete RFID card, so that it can be reassigned 
              </label>
            </div> */}
              <div className="btn-section-modal">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className="me-4 btn-sty w-100 rfid-btn"
                  sx={{ mr: 2, ...buttonStyle }}
                  // onClick={onSubmitModal}
                  onClick={onConfirm}
                >
                  {optionA}
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  className="btn-sty w-100 rfid-btn second"
                  sx={buttonStyle}
                  onClick={onSubmitModal}
                >
                  {optionB}
                </Button>
                </div>
                
            </div>
         </Box>
          </MuiModal>

        
        </>
    )
}
export default UserExistCheckModal;